import { useQuery } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { User } from '@interfaces/users';
import usersServices from 'src/services/users/usersServices';

export const useGetUserData = () => {
    const { user, isAuthenticated } = useAuth0();
    const query = useQuery<User, Error>(
      ['find-user-data', user?.sub],
      async () => {
        return await usersServices.findMe();
      },
      {
        enabled: isAuthenticated,
        retry: 1
      }
    );
    return query;
};